// extracted by mini-css-extract-plugin
export default {"btnHover":"SafeWeb_btnHover__xa4Hj"};